var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"packingLists app__page"},[_c('keep-alive',[_c(_vm.currentComponent,{tag:"component",on:{"switch-component":_vm.switchComponent}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }